import React from 'react';
import TopNavbar from '../Nav/TopNavbar';

import {
  Flex,
  Container,
  Heading,
  Stack,
  Text,
  Button,
  Icon,
  Image,
  Center,
  Box,

  useColorModeValue
} from '@chakra-ui/react';
import PricingCompo from './PricingCompo';
import FAQ from './FAQ';
import Reviews from './Reviews';
import NewNavbar from '../Nav/NewNavbar';
import Contact from '../Sections/Footer';

const OurProducts = () => {
  return (
    <>
      <NewNavbar />

      <div>
        <Container maxW={'5xl'} marginTop={'80px'}>
          <Stack
            textAlign={'center'}
            align={'center'}
            spacing={{ base: 8, md: 10 }}
            pt={{ base: 20, md: 28 }}>
            <Heading
              fontWeight={600}
              fontSize={{ base: '4xl', sm: '5xl', md: '9xl' }}
              lineHeight={'110%'}>
              SOP Review{' '}
              <Text as={'span'} color={'orange.400'}>
                made easy
              </Text>
            </Heading>
            <Text color={'gray.500'} maxW={'3xl'}>
              Never miss a meeting. Never be late for one too. Keep track of your
              meetings and receive smart reminders in appropriate times. Read your
              smart “Daily Agenda” every morning.
            </Text>

            <Center>
            <Box
            mt={20}
  role={'group'}
  p={3}
  maxW={{ base: '330px', md: '700px' }}
  w={'full'}
  bg={useColorModeValue('white', 'gray.800')}
  boxShadow={'xl'}
  rounded={'lg'}
  pos={'relative'}
  zIndex={1}
>
  <Box
    rounded={'lg'}
    mt={-12}
    pos={'relative'}
    height={{ base: '150px', md: '500px' }}
    _after={{
      transition: 'all .3s ease',
      content: '""',
      w: 'full',
      h: 'full',
      pos: 'absolute',
      top: 5,
      left: 0,
      backgroundImage:
        'url(https://images.unsplash.com/photo-1535982330050-f1c2fb79ff78?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80)',
      filter: 'blur(15px)',
      zIndex: -1,
    }}
    _groupHover={{
      _after: {
        filter: 'blur(20px)',
      },
    }}
  >
    <Image
      rounded={'lg'}
      height={{ base: '150px', md: '500px' }}
      width={{ base: '282px', md: '600px' }}
      objectFit={'cover'}
      src="https://images.unsplash.com/photo-1535982330050-f1c2fb79ff78?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80"
    />
  </Box>
</Box>


            </Center>
          </Stack>
        </Container>
      </div>

      <div style={{ marginTop: '40px' }}>
        <PricingCompo />
      </div>
     
      <div style={{ marginTop: '160px' }}>
        <FAQ />
      </div>
      <div style={{ marginTop: '80px' }}>

        <Reviews />
      </div>
      <Contact/>
    </>
  );
};

export default OurProducts;
